"use strict";
import { __module as a } from "./index.es284.js";
import { __require as f } from "./index.es275.js";
import { __require as c } from "./index.es285.js";
var i;
function g() {
  return i ? a.exports : (i = 1, (function(o, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "addLocale", {
      enumerable: !0,
      get: function() {
        return l;
      }
    });
    const d = f(), l = function(t) {
      for (var u = arguments.length, n = new Array(u > 1 ? u - 1 : 0), r = 1; r < u; r++)
        n[r - 1] = arguments[r];
      return process.env.__NEXT_I18N_SUPPORT ? (0, d.normalizePathTrailingSlash)(c().addLocale(t, ...n)) : t;
    };
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), o.exports = e.default);
  })(a, a.exports), a.exports);
}
export {
  g as __require
};
//# sourceMappingURL=index.es254.js.map
